import React from "react"

import classNames from "classnames"

import { getProjectPhaseColor } from "shared/lib/project-phase/getProjectPhaseColor"
import { WithClassName } from "shared/types/WithClassName"
import { Chip } from "shared/ui/chip/Chip"

export interface ProjectPhaseChipProps extends WithClassName {
  phase: { label: string; value: string } | null | undefined
  isLoading?: boolean
}

export const ProjectPhaseChip = React.memo(
  ({ phase, isLoading, className }: ProjectPhaseChipProps) => {
    return (
      <Chip
        className={classNames(
          "chip--small",
          isLoading ? undefined : getProjectPhaseColor(phase?.value),
          className
        )}
        isLoading={isLoading}
        isHidden={!phase && !isLoading}
      >
        {phase?.label}
      </Chip>
    )
  }
)
